import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Link from 'components/Link';
import { unibrow as UnibrowPropType } from 'lib/CustomPropTypes';

const block = 'unibrow';

// External Link SVG Icon
const SVG = () => (
  <span className="unibrow__external-link-icon">
    <svg
      width="12"
      height="12"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="unibrow__external-link-svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4 3H2.4H0V5.4V18.6V19.8V21H24L24 19.8L24 18.6L24 12.6H21.6V18.6H2.4V5.4H14.4V3ZM21.4368 7.63675L24 10.2V3H16.8L19.7397 5.93969L12.5397 13.1397L14.2368 14.8368L21.4368 7.63675Z"
        className="unibrow__external-link-path"
        fill="#0f0f19"
      />
    </svg>
  </span>
);

const Unibrow = ({
  children,
  className,
  size: HTag,
  target,
  unibrow,
  deepLink,
}) => {
  if (!unibrow) return null;

  let deepLinkingText = null;
  let deepLinkingUrl = null;

  if (deepLink) {
    // Adding DeepLinking Text + SVG icon
    if (deepLink.text) {
      deepLinkingText = (
        <span className="unibrow__external-link-container">
          {deepLink.text}
          {SVG()}
        </span>
      );
    }
    // Adding DeepLinking URL
    deepLinkingUrl = deepLink.url;
  }

  let element = (
    <span data-test="unibrow-text">
      {deepLinkingText || unibrow.override || unibrow.text || ''}
    </span>
  );

  if (deepLinkingUrl || (unibrow && unibrow.url && unibrow.url.primary)) {
    const unibrowUrl = deepLinkingUrl || unibrow.url.override || unibrow.url.primary;
    element = (
      <Link href={unibrowUrl} target={target}>
        {element}
      </Link>
    );
  }

  return (
    <HTag className={classNames(block, 'articleTitleSection', className)}>
      {element}
      {children}
    </HTag>
  );
};

Unibrow.propTypes = {
  unibrow: UnibrowPropType.isRequired,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  size: PropTypes.string,
  target: PropTypes.string,
  deepLink: PropTypes.objectOf(PropTypes.any),
};

Unibrow.defaultProps = {
  className: '',
  children: null,
  size: 'h2',
  target: null,
  deepLink: null,
};

export default Unibrow;
